import { patch } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { useMutation } from "@tanstack/react-query";

const useOrderSessionsMerge = () => {
  const branchId = useBranchId();
  const mutation = useMutation({
    mutationFn: ({
      from_session_id,
      to_session_id,
    }: {
      from_session_id: number;
      to_session_id: number;
    }) =>
      patch(
        `/internal/secure/pos/v1/order/sessions/merge/${branchId}/${from_session_id}/${to_session_id}`
      ),
  });

  return mutation;
};

export default useOrderSessionsMerge;
